import React from 'react';
import { Text, Link } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { Container, Row, RowChild } from 'styles';
import { HeadingAndText } from 'components/heading-and-text';

const getCopy = copyFor('settings.utilitySyncCredential.utilityCompany');

interface Props {
  url: string | null;
  utilityName: string;
}

export const UtilityRow = ({ url, utilityName }: Props) => (
  <Row>
    <RowChild alignItems="flex-start" xsmall={{ direction: 'column' }}>
      <HeadingAndText
        heading={
          <Text textStyle="heading500" tag="h3">
            {getCopy('title')}
          </Text>
        }
        text={utilityName}
      />
      {url && (
        <Container
          margin={{ left: '24px' }}
          xsmall={{ margin: { left: '0', top: '8px' } }}
        >
          <Link type="CTA" backgroundless size="small" href={url}>
            {getCopy('link')}
          </Link>
        </Container>
      )}
    </RowChild>
  </Row>
);
